"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const filter_1 = require("../../utils/filter");
const sort_1 = require("../../utils/sort");
function GroupsManagementPanel({ groups, filteredGroups, setFilteredGroups, filters, setFilters, }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const [filterPanelOpened, setFilterPanelOpened] = (0, react_1.useState)(false);
    const [sort, setSort] = (0, react_1.useState)(0);
    const [filter, setFilter] = (0, react_1.useState)(filters[0].items[0].identifier);
    const [panelOffset, setPanelOffset] = (0, react_1.useState)({
        bottom: 0,
        left: 0,
        right: 0,
    });
    const sortDropdownRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!sortDropdownRef.current) {
            return;
        }
        setPanelOffset({
            bottom: sortDropdownRef.current.getBoundingClientRect().bottom,
            left: sortDropdownRef.current.getBoundingClientRect().left,
            right: sortDropdownRef.current.getBoundingClientRect().right,
        });
    }, []);
    (0, react_1.useEffect)(() => {
        const filtered = (0, filter_1.filterGroups)(filter, groups);
        (0, sort_1.sortGroups)(sort, filtered, setFilteredGroups);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groups]);
    const filtersPanelOffsetBottom = panelOffset.bottom - 35;
    const filtersPanelOffsetLeft = panelOffset.left - panelOffset.right / 4;
    const onSort = (index) => {
        setSort(index);
        (0, sort_1.sortGroups)(index, filteredGroups, setFilteredGroups);
    };
    const onFilterOpen = () => {
        setFilterPanelOpened(true);
    };
    const onFilterClose = () => {
        setFilterPanelOpened(false);
    };
    const onFilterSubmit = (identifier) => {
        setFilteredGroups((0, filter_1.filterGroups)(identifier, groups));
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onSelectFilter = (categoryType, identifier) => {
        const newFilter = (0, filter_1.toggleSelectFilter)(filters, identifier);
        setFilter(identifier);
        setFilters(newFilter);
    };
    return ((0, jsx_runtime_1.jsxs)(Panel, { ref: sortDropdownRef, "data-e2e": 'GroupsManagementPanel_Panel', children: [(0, jsx_runtime_1.jsx)(StyledSort, { "data-e2e": 'GroupsManagementPanel_StyledSort', children: (0, jsx_runtime_1.jsx)(ui_1.SortDropdown, { options: sort_1.SORT_OPTIONS, tooltipTop: isMobile ? 45 : filtersPanelOffsetBottom, tooltipLeft: isMobile ? undefined : filtersPanelOffsetLeft, onOpen: () => { }, onChange: () => { }, selectSort: onSort, "data-e2e": 'GroupsManagementPanel_SortDropdown' }) }), (0, jsx_runtime_1.jsx)(ui_1.FiltersButton, { onClick: onFilterOpen, panelOpened: filterPanelOpened, "data-e2e": 'GroupsManagementPanel_FiltersButton' }), (0, jsx_runtime_1.jsx)(ui_1.FiltersPanel, { opened: filterPanelOpened, offset: 10, onClose: onFilterClose, filter: filters, activeContentType: bridge_schema_1.ContentType.Unknown, onSubmit: onFilterClose, selectItem: onFilterSubmit, showSubmitBtn: true, selectFilter: onSelectFilter, "data-e2e": 'GroupsManagementPanel_FiltersPanel' })] }));
}
exports.default = GroupsManagementPanel;
const Panel = styled_components_1.default.div `
  display: flex;
  border-top: 1px solid ${props => props.theme.secondary};
  padding: 5px 0 0 0;
`;
const StyledSort = styled_components_1.default.div `
  width: 100%;
  border-right: 1px solid ${props => props.theme.secondary};
`;
